import { makeObservable, observable } from "mobx"
import { PostElementBackground } from "@serializers/article"

import { BaseModel } from "./base.model"

export class ContactUsModel extends BaseModel {
  // @ts-ignore
  constructor(params) {
    super(params)
    makeObservable(this)
  }

  @observable title = "" as string
  @observable elements = [] as Block[]
  @observable translations = [] as Translation[]

  getContactUsPage = async () => {
    try {
      const {
        title,
        elements,
        translations,
      } = await this.Providers.ContactUsProvider.find(
        this.Models.GlobalModel.lang,
      )
      this.applyData({
        title,
        elements,
        translations,
      })
    } catch {}
  }

  getTextByKey = (key: string) => {
    return (
      this.translations.find((translation) => translation.key === key)?.value ??
      ""
    )
  }

  hydrate = (data: unknown) => {
    // @ts-ignore
    this.applyData({ title: data?.title })
    // @ts-ignore
    this.applyData({ elements: data?.elements })
    // @ts-ignore
    this.applyData({ translations: data?.translations })
  }

  serialize = () => {
    return {
      title: this.title,
      elements: this.elements,
      translations: this.translations,
    }
  }
}

export interface Block {
  background: PostElementBackground
  Content: string
}

export interface Translation {
  id: number
  key: string
  value: string
}
